package com.xtream.composeapp.viewmodel





import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.dto.ServerConfig
import com.xtream.data_kmp.remote.createApiService
import com.xtream.data_kmp.util.exception.getErrorMessage
import io.ktor.client.statement.bodyAsText
import io.ktor.http.isSuccess
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

class ServerConfigViewModel (
    private  val appSettingsRepo: PreferencesRepo

):ViewModel() {


    var serverConfigState by mutableStateOf<ApiSealed<ServerConfig>?>(ApiSealed.Initial)
        private set
    var serverConfig by mutableStateOf<ServerConfig?>(null)
        private set
    val activationServerUrl = appSettingsRepo.readFromDataStore.map {  it.activationServerUrl }


    private val coroutineExceptionHandler = CoroutineExceptionHandler { _, throwable ->
        throwable.printStackTrace()
    }

    fun loadServerConfigs() {


        viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            serverConfigState = ApiSealed.Loading

            try {
                val jsn =     Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                    encodeDefaults = false
                    explicitNulls = true
                }
                /*val client = HttpClient(OS.Android) {
                    if (Build.VERSION.SDK_INT <= Build.VERSION_CODES.N) {
                        engine {
                            sslManager = { httpsURLConnection ->
                                httpsURLConnection.sslSocketFactory =
                                    KtorSslHelper.getUnsafeSSLSocketFactory()
                                httpsURLConnection.hostnameVerifier =
                                    HostnameVerifier { _, _ -> true }
                            }
                        }
                    }
                    install(Logging) {
                        level = LogLevel.ALL
                    }




                    install(ContentNegotiation) {

                 json(jsn)
                    }
                }*/
                val client = createApiService(SharedBuildKonfig.SERVER_CONFIG)
                val response = client.getServerConfigs()/*client.get {
                    url(SharedBuildKonfig.SERVER_CONFIG)
                    //parameter("username", username)
                    //parameter("password", password)
                }*/
                if (response.status.isSuccess()) {
                    //Log.d(javaClass.simpleName, response.body())
                   // val json = response.bodyAsText().decodeBase64String()
                   // Log.d(javaClass.simpleName, json)

                    //val body = response.body<ServerConfig>()
                    val base64Body = response.bodyAsText()
                    @OptIn(ExperimentalEncodingApi::class)
                    val decoded= Base64.decode(base64Body)
                    val stringBody = decoded.decodeToString()
                   // Log.d("tttttt", stringBody)
                    // Step 3: Deserialize JSON string
                    val body =  jsn.decodeFromString<ServerConfig>(stringBody)
                        //Json.decodeFromString<ServerConfig>(json)//

                    serverConfigState = ApiSealed.Success(body)
                    serverConfig = body
                    with(appSettingsRepo){
                        editPref(PreferencesRepo.ACTIVATION_SERVER_URL_KEY, body.serverUrl?:"")
                        editPref(PreferencesRepo.ACCOUNT_SERVER_URL_KEY, body.accountServerUrl?:"")
                        editPref(PreferencesRepo.ACTIVATION_XOR_KEY, body.xorKey?:"")
                        editPref(PreferencesRepo.SERVER_USER_AGENT_KEY, body.userAgent?:"")
                        editPref(PreferencesRepo.SERVER_TMDB_KEY, body.tmdbKey?:"")
                        editPref(PreferencesRepo.SUBTITLE_KEY, body.subtitleKey?:"")
                    }


                } else {
                    serverConfigState = ApiSealed.Error("Error code ${response.status}")

                }


            } catch (e: Exception) {
//Log.d("ConfigError", e.toString())
                serverConfigState = ApiSealed.Error(e.getErrorMessage())
            }


        }

    }


}

